var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "language-list" },
    [
      _c(
        "profile-form",
        {
          ref: "form",
          attrs: { endpoint: "local-mo" },
          on: {
            error: function ($event) {
              return _vm.$emit("done", $event)
            },
          },
        },
        [
          _c("form", { staticClass: "form" }, [
            _c(
              "fieldset",
              { staticStyle: { padding: "0" } },
              [
                _c("legend", { staticClass: "sr-only" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.accessibilityTitle) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("simple-list", {
                  ref: "hotelList",
                  staticClass: "req",
                  attrs: {
                    id: "hotelList",
                    "server-items": _vm.hotelOptions,
                    variant: "hotels-list",
                    "internal-scroll": "",
                    height: _vm.listHeight,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "filter",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              ref: "hotelListHeader",
                              staticClass: "language-list-header",
                            },
                            [
                              _c("local-mo-list-search-bar", {
                                attrs: {
                                  "search-placeholder": _vm.searchPlaceholder,
                                },
                                on: { "filter-items": _vm.filterItems },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "card-template",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("local-mo-list-card", {
                            key: JSON.stringify(item),
                            attrs: {
                              item: item,
                              "search-input": _vm.inputString,
                              "query-changed": _vm.queryChanged,
                              "selected-hotel": _vm.selectedHotel,
                            },
                            on: { "destination-selected": _vm.updateFilter },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "islocalMOPreferences" },
                  domProps: { value: true },
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "hotel" },
                  domProps: { value: _vm.localProfile.localMOPreference },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.hotelOptions && _vm.loading ? _c("loading-dots") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }